<template>
  <div class="e-horizon-search-form-container">
    <form ref="searchForm">
      <input
        type="hidden"
        name="action2"
        value="avail"
      />

      <input
        type="hidden"
        name="p"
        value="bti"
      />

      <input
        type="hidden"
        name="pos"
        :value="selectedCountry"
      />
      <input
        type="hidden"
        name="l"
        :value="$i18n.locale()"
      />
      <input
        type="hidden"
        name="traveltype"
        value="bti"
      />
      <input
        type="hidden"
        name="origin"
        :value="origin.value.code"
      />
      <input
        type="hidden"
        name="originType"
        :value="origin.value.type"
      />
      <input
        type="hidden"
        name="destin"
        :value="destin.value.code"
      />
      <input
        type="hidden"
        name="destinType"
        :value="destin.value.type"
      />
      <input
        v-if="showPaxField('adults')"
        type="hidden"
        name="numadt"
        :value="paxSelector.adults"
      />
      <input
        v-if="showPaxField('children')"
        type="hidden"
        name="numchd"
        :value="paxSelector.children"
      />
      <input
        v-if="showPaxField('infants')"
        type="hidden"
        name="numinf"
        :value="paxSelector.infants"
      />

      <div
        v-if="isDesktop"
        class="passengers-triptype-wrap"
      >
        <dropdown
          tabindex="0"
          :items="tripTypes"
          :selected-item="tripType"
          @select="onTripTypeChanged"
        />

        <div class="passengers-block">
          <pax-selector-block
            ref="paxSelector"
            v-focusout="paxSelectorClose"
            tabindex="0"
            focus-out-force-open="openPaxSelector"
            :class="{ error: paxHasErrors }"
            :pax-selector="paxSelector"
            @clicked="onPaxClicked"
            @focus="onPaxClicked"
          />
        </div>
      </div>

      <div
        v-if="!isDesktop"
        class="passengers-triptype-wrap"
      >
        <dropdown
          tabindex="0"
          :items="tripTypes"
          :selected-item="tripType"
          @select="onTripTypeChanged"
        />

        <div class="passengers-block">
          <pax-selector-block
            ref="paxSelector"
            v-focusout="paxSelectorClose"
            tabindex="0"
            focus-out-force-open="openPaxSelector"
            :class="{ error: paxHasErrors }"
            :pax-selector="paxSelector"
            @clicked="onPaxClicked"
            @focus="onPaxClicked"
          />
        </div>
      </div>

      <div class="wrap">
        <div
          class="from-to-block"
          :class="{ 'swap-visible': isOrigDestSwappable }"
        >
          <origin
            ref="origin"
            v-focusout="onOriginOpenUpdate"
            :filter="origin.typeahead.filter"
            :touched="origin.typeaheadIgnoreFilter"
            :value="origin.value"
            :open="origin.typeahead.open"
            class="e-horizon-orig-destin origin"
            :class="{ error: origin.hasErrors, 'blue-border': isFocusOnOrigin }"
            :options="filteredOrigins(true, true)"
            :is-mobile="deviceType"
            :label="$t('searchForm.originDestin.origin.fromEHorizon')"
            :choose="$t('searchForm.originDestin.origin.originChooseEHorizon')"
            :labels="originLabels"
            :selected-label="origin.selectedLabel"
            :invalid-input-lang="originValidator.state.filter.$invalid"
            :placeholder="$t('searchForm.originDestin.origin.placeholderEHorizon')"
            :translation-no-results="$t('searchForm.originDestin.noResultsEHorizon')"
            :translation-invalid-language="wrongInputLangTranslation"
            @update:filter="onOriginFilter"
            @focused="showOriginTypeahead"
            @update:open="onOriginOpenUpdate"
            @update:label="onOriginLabelUpdate"
            @update:value="onOriginSelect"
          />
          <destin
            ref="destin"
            v-focusout="onDestinOpenUpdate"
            :filter="destin.typeahead.filter"
            :touched="destin.typeaheadIgnoreFilter"
            :value="destin.value"
            :open="destin.typeahead.open"
            class="e-horizon-orig-destin destin"
            :class="{ error: destin.hasErrors, 'blue-border': isFocusOnDestin }"
            :options="filteredDestins(true, true)"
            :is-mobile="deviceType"
            :label="$t('searchForm.originDestin.destin.toEHorizon')"
            :choose="$t('searchForm.originDestin.destin.destinChooseEHorizon')"
            :labels="destinLabels"
            :selected-label="destin.selectedLabel"
            :invalid-input-lang="destinValidator.state.filter.$invalid"
            :placeholder="$t('searchForm.originDestin.destin.placeholderEHorizon')"
            :translation-no-results="$t('searchForm.originDestin.noResultsEHorizon')"
            :translation-invalid-language="wrongInputLangTranslation"
            @update:filter="onDestinFilter"
            @focused="onDestinFocused"
            @update:open="onDestinOpenUpdate"
            @update:label="onDestinLabelUpdate"
            @update:value="onDestinSelected"
          />
          <swap-icon
            v-if="isOrigDestSwappable"
            @swap="swapOrigDest"
          />
        </div>

        <trip-dates :calendar-icon="true" />

        <div
          class="btn btn-blue btn-search"
          :class="{ 'btn-disabled': !isSubmitDisabled }"
        >
          <button
            tabindex="0"
            @click.prevent="submitTimetableForm"
          >
            {{ $t('searchForm.submitButton.timetable') }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import Origin from 'components/eHorizon/Destination/Origin'
  import Destin from 'components/eHorizon/Destination/Destin'
  import PaxSelectorBlock from 'components/eHorizon/PaxSelector/PaxSelectorBlock'
  import PaxSelectorMixin from 'components/eHorizon/SearchFormMixins/PaxSelector'
  import OriginMixin from 'components/eHorizon/SearchFormMixins/Origin'
  import DestinMixin from 'components/eHorizon/SearchFormMixins/Destin'
  import TripTypeMixin from 'components/eHorizon/SearchFormMixins/TripType'
  import SearchForm from 'components/eHorizon/SearchFormMixins/SearchForm'
  import Focusout from 'utils/directives/FocusOut'
  import ModalMixin from 'components/Modal/mixins/Modal'
  import Dropdown from 'components/Dropdown/DropdownWithoutModal'
  import SwapIcon from 'components/eHorizon/SwapIcon'
  import TripDates from 'components/eHorizon/TripDates'
  import isEmpty from 'lodash-es/isEmpty'
  import isUndefined from 'lodash-es/isUndefined'
  import get from 'lodash-es/get'
  import every from 'lodash-es/every'

  export default {
    directives: {
      Focusout
    },
    components: {
      Origin,
      Destin,
      Dropdown,
      SwapIcon,
      PaxSelectorBlock,
      TripDates
    },
    mixins: [
      PaxSelectorMixin,
      OriginMixin,
      DestinMixin,
      TripTypeMixin,
      SearchForm,
      ModalMixin
    ],
    data() {
      return {
        tripTypes: [
          {
            title: this.$t('searchForm.radio.roundTripEHorizon'),
            value: 'return'
          },
          {
            title: this.$t('searchForm.radio.oneWayEHorizon'),
            value: 'oneway'
          }
        ]
      }
    },
    computed: {
      ...mapState('eHorizonSearchForm', [
        'paxSelector',
        'tripType',
        'destin',
        'origin',
        'origDestData',
        'calendar',
        'formValid'
      ]),
      ...mapGetters('eHorizonSearchForm/origin', {
        originLabels: 'originLabels',
        originValidator: '$v'
      }),
      ...mapGetters('eHorizonSearchForm/destin', {
        destinLabels: 'destinLabels',
        destinValidator: '$v'
      }),
      ...mapGetters('eHorizonSearchForm', ['filteredOrigins', 'filteredDestins']),
      ...mapState('main', ['selectedCountry']),
      ...mapState('device', ['deviceType']),
      ...mapGetters('device', ['isDesktop']),
      wrongInputLangTranslation() {
        return this.$i18n.locale() === 'ru'
          ? this.$t('searchForm.originDestin.invalidLanguageEHorizonCyrillic')
          : this.$t('searchForm.originDestin.invalidLanguageEHorizon')
      },
      isFocusOnOrigin() {
        return get(this.origin, 'value.code', null) === null
      },
      isFocusOnDestin() {
        if (this.isFocusOnOrigin) {
          return false
        }

        return get(this.destin, 'value.code', null) === null
      },
      isSubmitDisabled() {
        const origin = every(
          [this.isFocusOnOrigin, this.isFocusOnDestin],
          (e) => e === false
        )
        const check =
          origin &&
          this.calendar.departureDate !== '' &&
          this.calendar.departureErrors.length === 0
        if (['return', 'multi'].includes(this.tripType)) {
          return (
            check &&
            this.calendar.returnDate !== '' &&
            this.calendar.returnErrors.length === 0
          )
        }

        return check
      },
      isOrigDestSwappable() {
        if (isEmpty(this.origin.value) || isEmpty(this.destin.value)) {
          return false
        }

        const originAirportCode = this.origin.value.code + this.origin.value.type
        const destinAirportCode = this.destin.value.code + this.destin.value.type

        if (
          isUndefined(this.origDestData[`${destinAirportCode}`]) ||
          isUndefined(this.origDestData[`${destinAirportCode}`].destinations)
        ) {
          return false
        }

        return !isUndefined(
          this.origDestData[`${destinAirportCode}`].destinations[`${originAirportCode}`]
        )
      },
      showDestinationBlock() {
        return Object.keys(get(this.ripTexts, 'destinations', [])).length > 0
      },
      paxHasErrors() {
        return this.paxSelector.groupBooking
      }
    },
    methods: {
      swapOrigDest() {
        this.$store.dispatch('eHorizonSearchForm/swapOrigWithDest')
      },
      showPaxField(field) {
        return typeof this.paxSelector !== 'undefined' && this.paxSelector[`${field}`] > 0
      },
      submitTimetableForm() {
        this.$store.commit('main/showPlaneLoader', true)
        this.validateStep()
          .then(() => {
            this.$store.commit('timetable/setFormSubmitted', {
              origin: this.origin.value,
              destination: this.destin.value
            })
            this.$emit('getTimetable')
          })
          .catch((e) => e)
          .finally(() => this.$store.commit('main/showPlaneLoader', false))
      },
      validateOriginDestin() {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('eHorizonSearchForm/validateComponents', null, {
            root: true
          })

          if (this.formValid) {
            return resolve()
          } else {
            return reject('validateOriginDestin')
          }
        })
      },
      validateStep() {
        const rules = [
          this.validateOriginDestin(),
          this.$store.dispatch('eHorizonSearchForm/calendar/validateDeparturePromise')
        ]

        if (['return', 'multi'].includes(this.tripType)) {
          rules.push(
            this.$store.dispatch('eHorizonSearchForm/calendar/validateReturnPromise')
          )
        }

        return Promise.all(rules)
          .then(() => Promise.resolve(true))
          .catch((e) => Promise.reject(e))
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';
  @import '~assets/styles/containers/search-form.scss';

  ::v-deep .field-wrapper,
  ::v-deep .trip-dates-wrapper {
    max-width: none;
  }

  ::v-deep .e-horizon-typeahead {
    .input-container {
      .placeholder {
        @include bp-mf-desktop {
          @include text-overflow;
          width: calc(100% - 48px);
        }
      }
    }
  }

  ::v-deep .wrapper {
    order: 3;
    width: 100%;
    max-width: 375px;
    margin: 0 auto 12px;

    @include bp-mf-tablet {
      max-width: none;
    }

    @include bp-mf-desktop {
      max-width: 375px;
    }

    ::v-deep .trip-dates-wrapper,
    ::v-deep .field-wrapper {
      height: 56px;
      max-width: none;

      .date-field-group {
        margin-bottom: 0;

        ::v-deep .date-field-wrap {
          border: 1px solid $grey-border;

          @include bp-mf-desktop {
            border-radius: 0;
            border-right: initial;
          }

          input {
            @include bp-mf-tablet {
              height: 34px;
            }
          }
        }
      }
    }

    ::v-deep .date-field-group {
      width: calc(50% - 2px);

      @include bp-mf-tablet {
        width: calc(50% - 4px) !important;
      }

      @include bp-mf-desktop {
        margin-bottom: 0;
        width: 50%;
        border-radius: 0;
      }

      input {
        @include bp-mf-desktop {
          height: 27px;
          line-height: 25px;
        }
      }
    }
  }

  .from-to-block {
    @include bp-mf-tablet {
      margin-bottom: 12px !important;
    }

    @include bp-mf-desktop {
      margin-bottom: 0 !important;
      width: 100%;
    }

    &.swap-visible {
      .swap-icon {
        z-index: 2;

        @include bp-mf-desktop {
          transform: none;
          right: auto;
          left: calc(50% - 16px);
          top: calc(50% - 16px);
        }
      }
    }
  }

  .passengers-block {
    order: 4;
    width: 100%;
    max-width: 375px;
    margin: 0 auto;
  }

  ::v-deep .passengers-triptype-wrap {
    order: 0 !important;

    .dropdown-wrap {
      border: 1px solid $grey-border-light;
    }

    .pax-selector-block {
      border: 1px solid $grey-border-light;
    }
  }

  .btn {
    order: 5;
    height: 48px;
    line-height: 48px;

    &.btn-disabled {
      border: 1px solid $gray-border;

      @include bp-mf-tablet {
        border: none;
      }
    }
  }
</style>
